<section class="mod-page ocr-shell" data-module="documentOcr">
  <header class="page-header">
    <div>
      <p class="eyebrow">Records Officer · Case Intake AI</p>
      <h1>Document Intake</h1>
    </div>
  </header>

  <nav class="ocr-tabs" aria-label="Document OCR sections">
    @for (t of tabs; track t.path) {
      <a [routerLink]="t.path" routerLinkActive="active">{{ t.label }}</a>
    }
  </nav>

  <router-outlet />
</section>
